// extracted by mini-css-extract-plugin
export default {"body":"MiniTooltip-module--body--hvsff"};